import { useState } from 'react';
import ClientDocumentsApi from '../../../../services/api/clientDocumentsApi';
import { fileTypeWillOpen } from '../../Shared/resources/DoxFileTypes';
import { DoxFileDownloadStatus, DoxFileOperations } from '../services/doxExplorerConsts';
import { useUnauthorizedContext } from '../../Shared/hooks/useUnauthorizedContextHook';
import { ApiPaths } from '../../Shared/services/ApiPaths';
import fileDownloadUtil from '../services/FileDownloadUtil';
import { browserShouldOpenInTab } from '../../Shared/services/Util';

export const useFileDownload = () => {
    const [loadingFiles, setLoadingFiles] = useState([]);
    const handleUnauthorized = useUnauthorizedContext()

    const handleFileAction = async (action, documentId, fileNamePart, fileType, callback = () => { }) => {
        if (loadingFiles.includes(documentId)) {
            callback(documentId, DoxFileDownloadStatus.IN_PROGRESS)
            return;
        }

        const api = ClientDocumentsApi.create(handleUnauthorized);
        let newTab = false
        setLoadingFiles([...loadingFiles, documentId])

        try {
            const response = await api.downloadDocument(documentId);
            if (response && response.status === 200 && response.data) {
                // get the filename
                let fileName = fileNamePart + fileType

                // parse binary response data into fancy blob
                let fileLink = URL.createObjectURL(response.data);

                // do something with it
                if (action === DoxFileOperations.DOWNLOAD) {
                    // otherwise, just download
                    fileDownloadUtil.downloadFile(fileLink, fileName, false)
                } else {
                    let fileOpens = fileTypeWillOpen(fileType);
                    let openInTab = browserShouldOpenInTab();
                    fileDownloadUtil.downloadFile(fileLink, fileName, action === 'view' && fileOpens && openInTab)
                }

                callback(documentId, DoxFileDownloadStatus.COMPLETE)
            } else if (response && response.status === 404) {
                callback(documentId, DoxFileDownloadStatus.FAIL_NO_SUCH_FILE)
            } else {
                callback(documentId, DoxFileDownloadStatus.FAIL_TRANSIENT)
            }
        } catch (error) {
            console.log(error)
            callback(documentId, DoxFileDownloadStatus.FAIL_TRANSIENT)
        } finally {
            setLoadingFiles(loadingFiles.filter(x => x.documentId !== documentId))
        }
    }  

    const printFile = (pdfLink, newTab) => {
        if (newTab) {
            let myWindow = window.open();
            myWindow.location.href = pdfLink
        }
        else {
            let iframe = window.frames['file-print']

            // javascript IFRAME magic! (ew.)
            if (!iframe) {
                iframe = document.createElement('iframe')
                iframe.id = 'file-print'
                iframe.style.visibility = 'hidden'
                iframe.onload = function () {
                    setTimeout(function () {
                        iframe.focus();
                        iframe.contentWindow.print();
                    }, 1);
                };
                document.body.appendChild(iframe)
            }

            iframe.src = pdfLink;
        }
    }


    return [loadingFiles, handleFileAction]
}